import $ from "jquery"

/**
 * Define values for key codes
 * @public object
 */
export const keyCodes = {
	tab: 9,
	enter: 13,
	esc: 27,
	space: 32,
	pageup: 33,
	pagedown: 34,
	end: 35,
	home: 36,
	left: 37,
	up: 38,
	right: 39,
	down: 40,
}

/**
 * Define values for key directions
 * @public object
 */
export const keyDirections = {
	37: -1,
	38: -1,
	39: 1,
	40: 1,
}

/**
 * Accessibility
 * @public class
 */
class Accessibility {
	constructor() {
		this._initEvents()
	}

	_initEvents() {
		$(document).on("keydown mousedown", this._onTabFocus)
	}

	_onTabFocus(event) {
		document.body.classList.toggle("key-mode", event.type === "keydown")
	}
}

export default Accessibility
